import React from "react";
import { AlertCircle } from "lucide-react";
import "./FeatureNotAvailable.scss";

const FeatureNotAvailable = ({ featureName }) => {
  return (
    <section
      className="feature-not-available"
      role="alert"
      aria-labelledby="feature-not-available-title"
    >
      <div className="feature-not-available__card">
        <div className="feature-not-available__icon">
          <AlertCircle size={34} strokeWidth={1.75} aria-hidden="true" />
        </div>

        <span className="feature-not-available__badge">
          Feature Restricted
        </span>

        <h1
          id="feature-not-available-title"
          className="feature-not-available__title"
        >
          This feature isn't available
        </h1>

        <p className="feature-not-available__description">
          Your organization doesn't currently have access to this feature.
          Contact your administrator if you believe this feature should be
          enabled.
        </p>

        {featureName && (
          <div className="feature-not-available__meta">
            <span className="feature-not-available__label">
              Feature Flag
            </span>

            <code className="feature-not-available__code">
              {featureName}
            </code>
          </div>
        )}
      </div>
    </section>
  );
};

export default FeatureNotAvailable;